const TARGETS = {
    UNIQUE_USERS: 'unique-users',
    AVERAGE_SESSION_TIME_AND_ACTIONS: 'avg-session-time-and-actions',
}

Object.freeze(TARGETS)

export default TARGETS
